define('vspot-angular/resources/activity-type-resource',[], function () {
    'use strict';

    return ['$resource', function ($resource) {
        // AngularJS allows us to define multiple parameters in the same portion of the URL template.
        // As long as you only use one parameter at a time, AngularJS will construct the RESTful resource properly.
        // For params, if it is prefixed with @, then the value of that parameter is extracted from the data object
        // (useful for non-GET operations). In other words, if :controller is defined, :id should not, and vice versa.
        return $resource('/api/activity_types/:controller:id',
            {
                id: '@id',
                controller: '@controller'
            },
            {
                query:  {
                    method:'GET',
                    cache: true
                }
            }
        );
    }];
});
